import { Manager, Notifications } from "@twilio/flex-ui";
import { NotificationIds } from "../flex-hooks/notifications/TransferResult";
import ChatTransferService, { buildRemoveMyPartiticipantAPIPayload } from "../helpers/APIHelper";
import { LeaveChatActionPayload } from "../types/ActionPayloads";

export const name = "LeaveChat";

export const handle = async (payload: LeaveChatActionPayload) => {
  const { conversation } = payload;
  const manager = Manager.getInstance();

  console.log("handleLeaveChatAction", conversation.source?.sid);

  const removePartcipantAPIPayload = await buildRemoveMyPartiticipantAPIPayload(conversation);

  if (!removePartcipantAPIPayload) {
    console.error("error building removePartcipantAPIPayload");
    Notifications.showNotification(NotificationIds.ChatRemoveParticipantFailed);
    return;
  }

  try {
    await new ChatTransferService(manager).removeParticipantAPIRequest(removePartcipantAPIPayload);
  } catch (error) {
    console.error("remove participant API request failed", error);
    Notifications.showNotification(NotificationIds.ChatRemoveParticipantFailed);
  }
};
